import styled from 'styled-components';
import Step from './Step';
import { ReactNode } from 'react';

type Props = {
  step?: string;
  title?: ReactNode;
  imgSrc?: string;
  contents?: ReactNode;
};

const Section = ({ step, title, imgSrc, contents }: Props) => {
  return (
    <Wrapper>
      {step && <Step step={step} />}
      {title && <Title>{title}</Title>}
      {imgSrc && <Img src={imgSrc} alt='' />}
      {contents && contents}
    </Wrapper>
  );
};
export default Section;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.strong`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 20px;
  font-weight: 700;
  line-height: 150%; /* 30px */
  letter-spacing: -0.4px;
`;

const Img = styled.img`
  width: 100%;
`;
